export default "__VITE_ASSET__BmMPGlcp__"